// ** React Imports
import { Fragment } from 'react';

import ComponentSpinner from '@components/spinner/Loading-spinner';
import ReactPaginate from 'react-paginate';
import DataTable from 'react-data-table-component';
import { ChevronDown } from 'react-feather';

import { CustomHeader } from './Header';

// ** Reactstrap Imports
import { Card, Row, Col } from 'reactstrap';

// ** Styles
import '@styles/react/libs/react-select/_react-select.scss';
import '@styles/react/libs/tables/react-dataTable-component.scss';
import { CustomFilters } from './Filters';

const TableComponent = ({
  store,
  data,
  loading,
  control,
  errors,
  setValue,
  columns,
  headerOptions,
  headerOptionsModal,
  handleDownload,
  loadingDownload,
  filterOptions,
  pagination
}) => {
  // ** Function in get data on page change
  const handlePagination = (page) => {
    const nextPage = page.selected + 1;
    setValue('page', nextPage);
  };

  // ** Custom Pagination
  const CustomPagination = () => {
    return (
      <ReactPaginate
        previousLabel={''}
        nextLabel={''}
        pageCount={data.totalPages || 1}
        activeClassName="active"
        forcePage={data.page !== 0 ? data.page - 1 : 0}
        onPageChange={(page) => handlePagination(page)}
        pageClassName={'page-item'}
        nextLinkClassName={'page-link'}
        nextClassName={'page-item next'}
        previousClassName={'page-item prev'}
        previousLinkClassName={'page-link'}
        pageLinkClassName={'page-link'}
        containerClassName={
          'pagination react-paginate justify-content-end my-2 pe-1'
        }
      />
    );
  };

  const NoDataRecords = () => {
    return (
      <Row>
        <Col md={12} className="text-align-center mt-4 mb-4">
          No hay registros que mostrar
        </Col>
      </Row>
    );
  };

  return (
    <Fragment>
      {filterOptions && (
        <CustomFilters
          control={control}
          errors={errors}
          filterOptions={filterOptions}
        />
      )}

      <Card className="overflow-hidden">
        <div className="react-dataTable">
          <DataTable
            noHeader
            subHeader
            sortServer
            pagination={pagination}
            responsive
            paginationServer
            columns={columns}
            progressPending={loading}
            progressComponent={<ComponentSpinner />}
            sortIcon={<ChevronDown />}
            noDataComponent={<NoDataRecords />}
            className="react-dataTable"
            paginationComponent={CustomPagination}
            data={store}
            subHeaderComponent={
              <CustomHeader
                headerOptions={headerOptions}
                headerOptionsModal={headerOptionsModal}
                handleDownload={handleDownload}
                loadingDownload={loadingDownload}
                control={control}
                errors={errors}
              />
            }
          />
        </div>
      </Card>
    </Fragment>
  );
};

export default TableComponent;
